import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GetDetailProject } from "../../api/projectapi";
import {
  MeetupBasicDataType,
  ProjectBasicDataType,
} from "../../interface/interface";
import { formatDate, PrjtCategory } from "../../lib/lib";
import "./css/index.css";
import CsvBtn from "../../components/CsvBtn/CsvBtn";
const csvHeader = [
  "유저넘버",
  "아이디",
  "닉네임",
  "실명",
  "번호",
  "이메일",
  "신청분야",
  "신청현황",
];
type LocationType = {
  pathname: string;
  state: {
    prjt_id: string;
    prjt_nm: string;
    rcrt_apply_en_at: string;
    leadr_usr_nm: string;
  };
};

function ProjectUserList() {
  const { pathname, state } = useLocation() as LocationType;
  const category = pathname.split("/")[1];
  const navigate = useNavigate();
  const [data, setdata] = useState<
    undefined | ProjectBasicDataType | MeetupBasicDataType
  >(undefined);
  const CsvUserData = useCallback((): any => {
    if (data) {
      return new Promise((resolve, reject) => {
        resolve(
          data.rcrt_apply_lst.map(
            ({
              apply_usr_nm,
              apply_usr_id,
              login_id,
              rcrt_nm,
              rcrt_usr_name,
              rcrt_usr_phone,
              usr_email,
              apply_sts_nm,
            }) => {
              return [
                apply_usr_id,
                login_id,
                apply_usr_nm,
                rcrt_usr_name,
                rcrt_usr_phone,
                usr_email,
                rcrt_nm,
                apply_sts_nm,
              ];
            }
          )
        );
      });
    }
  }, [data]);

  useEffect(() => {
    if (state.prjt_id) {
      GetDetailProject(state.prjt_id).then(({ state, data }) => {
        if (state) {
          setdata(data);
        }
      });
    }
    return () => {};
  }, [state]);

  return (
    <main className="project-user-list-page">
      {data ? (
        <div className="wrapper">
          <div className="header">
            <div
              className="back"
              onClick={() => {
                navigate(-1);
              }}
            >
              <img
                src="/assets/common/rightarrow.svg"
                className="img"
                alt="이동"
              ></img>
            </div>
            <div className="title">
              팀 {category === "prjt" ? "프로젝트" : "밋업"} 상세
            </div>
          </div>
          <div className="main">
            <div className="main_left">
              <div
                className="imagebox"
                style={{
                  backgroundImage: `url(${data.prjt_thumbnail})`,
                }}
              />
              <div className="title">{data.prjt_nm}</div>
              <div className="line"></div>

              <div className="sub">
                <div className="title">카테고리</div>
                <div className="box">
                  {data.prjt_type_cd === "prjt"
                    ? PrjtCategory[
                        data.prjt_ctg_cd as keyof typeof PrjtCategory
                      ]
                    : data.mtup_typ === "OFFLINE"
                    ? "대면"
                    : "비대면"}
                </div>
              </div>
              <div className="sub">
                <div className="title">모집일정</div>
                <div className="sub">
                  {formatDate(data.rcrt_apply_st_at, "-")}~{""}
                  {formatDate(data.rcrt_apply_en_at, "-")}
                </div>
              </div>
              <div className="sub">
                <div className="title">팀플시작</div>
                <div className="sub">
                  {data.prjt_apply_st_at
                    ? formatDate(data.prjt_apply_st_at, "-")
                    : "미정"}
                </div>
              </div>
              {category === "prjt" ? (
                <div className="sub">
                  <div className="title">모집분야</div>
                  <div className="sub">{data.rcrt_nm_agg}</div>
                </div>
              ) : undefined}
              <div className="sub">
                <div className="title">팀플리더</div>
                <div className="sub">{data.leadr_usr_nm}</div>
              </div>
            </div>
            <div className="main_right">
              <div className="title">
                <div className="left">
                  <img
                    src="/assets/common/vector.svg"
                    className="img"
                    alt=""
                  ></img>
                  신청자 리스트
                </div>
                <CsvBtn
                  headers={csvHeader}
                  getCsvData={CsvUserData}
                  title={`${data.prjt_nm} 신청자 리스트`}
                />
              </div>

              <div className="sub">
                <div className="menu">
                  <div className="name1">아이디</div>
                  <div className="name2">이메일</div>
                  <div className="name3">활동명</div>
                  <div className="name4">신청분야</div>
                </div>
              </div>

              <div className="list">
                {data.rcrt_apply_lst
                  .filter(
                    ({ apply_sts_cd }) => apply_sts_cd !== "apply_sts_cancel"
                  )
                  .map((item, index) => {
                    return (
                      <div key={index} className={`box`}>
                        <div className="name">{item.login_id}</div>
                        <div className="email">{item.usr_email}</div>
                        <div className="team">{item.apply_usr_nm}</div>
                        <div className="registration">{item.rcrt_nm}</div>
                        <button
                          className="list"
                          onClick={() => {
                            navigate("/portfolio/view", {
                              state: {
                                img: data.prjt_thumbnail,
                                type: data.prjt_type_cd,
                                prjt_nm: data.prjt_nm,
                                sub: item.apply_self_brif_1,
                                content: item.apply_self_brif_2,
                                link: item.usr_link,
                              },
                            });
                          }}
                        >
                          포트폴리오 보기
                        </button>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      ) : undefined}
    </main>
  );
}

export default ProjectUserList;
